import Environment from './type';
import { common } from './environment.common';

export const environment: Environment = {
  ...common,
  production: false,
  base_url: 'http://127.0.0.1:4200',
  login_url: 'login',
  sso_cert: './certs/argus_sso_cert.pem',
  sso_key: './certs/argus_sso_key.pem',
};
